import React from 'react';

import OrganizationHeader from '../containers/header/OrganizationHeader';
import OrganizationCover from '../containers/cover/OrganizationCover';
import OrganizationBuckets from '../containers/organizationBuckets/OrganizationBuckets';
import DashboardAnnouncementModal from '../components/modals/DashboardAnnouncementModal';

import isAuthorizedCurrentOrganization from '../hoc/CurrentOrganizationAuthorization';

class OrganizationBucketsPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showAnnouncement: true,
        };
    }

    handleCloseAnnouncement = () => {
        this.setState({ showAnnouncement: false });
    };

    render() {
        return (
            <React.Fragment>
                <OrganizationHeader />
                <OrganizationCover />
                <OrganizationBuckets />
                <DashboardAnnouncementModal
                    show={this.state.showAnnouncement}
                    onClose={this.handleCloseAnnouncement}
                />
            </React.Fragment>
        );
    }
}

export default isAuthorizedCurrentOrganization(OrganizationBucketsPage);



// WEBPACK FOOTER //
// ./src/pages/OrganizationBucketsPage.js